import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  min-width: 1140px;
`;

export const Heading = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  align-self: stretch;
`;
